import React from 'react';
import {ItemSearchBloodTestForm} from "../../../../../finalForms/templates/ItemSearchBloodTestForm";

export const BloodTest = (props) => {
  const { searchType } = props
  return (
      <div>
        <ItemSearchBloodTestForm searchType={searchType}/>
      </div>
  );
};
